import qs from 'qs';

const PollQuests = {
    namespaced: true,

    state: {
        pollQuestsData: [],
    },

    getters: {
        pollQuestsData(state) {
            return state.pollQuestsData;
        },
    },

    mutations: {
        /**
         * Установить значение объекта
         * @param state
         * @param items
         */
        setArr(state, { items }) {
            state['pollQuestsData'] = items;
        },

        /**
         * Обновить значение элемента объекта
         * @param state
         * @param item
         * @param index
         */
        setItem(state, { item, index }) {
            state['pollQuestsData'][index] = item;
        },

        /**
         * Добавить значение элемента объекта
         * @param state
         * @param item
         */
        addItem(state, { item }) {
            state['pollQuestsData'].push(item);
        },

        /**
         * Удалить элемент из объекта
         * @param state
         * @param item
         */
        remove(state, { item }) {
            state['pollQuestsData'] = state['pollQuestsData'].filter(iItem => iItem !== item);
        },

        /**
         * Передаем параметры вопроса в State
         * @param state
         * @param name Текст вопроса
         * @param dataType Тип данных ответа
         */
        setQuestionParams(state, { name, dataType }) {
            state['questionParams'] = {
                name: name,
                dataType: dataType
            };
        }
    },


    actions: {
        /**
         * Получение данных по уровням
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @returns {Promise<any>}
         */
        getPollQuestsData({ commit, dispatch, getters, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, { root: true });

                axios({
                    url: rootGetters.rootUrl + 'list/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.pollQuests
                    }),
                }).then(response => (
                    commit('setArr', {
                        items: response.data
                    }),
                    dispatch('loading/isLoading', false, { root: true }),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по вопросам в анкетах получены.'),
                    resolve(response)
                )).catch(err => {
                    dispatch('loading/isLoading', false, { root: true }),
                        console.log('ERROR IN pollQuests.js | getPollQuestsData: ' + err);
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка в получении данных по вопросам в анкетах!'),
                        reject(err);
                });
            })
        },

        /**
         * Сохранение данных по уровням
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        savePollQuestsData({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, { root: true });

                const str = JSON.stringify(data.data);

                axios({
                    url: rootGetters.rootUrl + 'list/save',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.pollQuests
                    }),
                }).then(response => {
                    // Если редактирование
                    if (data.index !== -1) {
                        commit('setItem', {
                            item: data.data,
                            index: data.index
                        });
                        dispatch('loading/isLoading', false, { root: true });
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по уровням успешно отредактированы!');
                        // Если сохранение нового
                    } else {
                        if (typeof data.data.id != 'undefined') {
                            data.data.id = response.data[0].id;
                            commit('addItem', {
                                item: data.data
                            });
                        }

                        dispatch('loading/isLoading', false, { root: true });
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Новый уровень успешно создан!');
                    }

                    resolve(response);
                }).catch(err => {
                    dispatch('loading/isLoading', false, { root: true });
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении данных!');
                    console.log('ERROR IN pollQuests.js | savePollQuestsData: ' + err);
                    reject(err);
                });
            })
        },

        /**
         * Удаление уровня
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        removePollQuestsData({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, { root: true });

                const str = JSON.stringify(data.item);

                axios({
                    url: rootGetters.rootUrl + 'list/delete',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.pollQuests
                    }),
                }).then(response => (
                    commit('remove', {
                        item: data.item
                    }),
                    dispatch('loading/isLoading', false, { root: true }),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Уровни успешно удалены!'),
                    resolve(response)
                )).catch(err => {
                    dispatch('loading/isLoading', false, { root: true });
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при удалении уровня!'),
                        console.log('ERROR IN pollQuests.js | removePollQuestsData: ' + err);
                    reject(err);
                });
            })
        },

        /**
         * Передача параметров вопроса
         * @param commit
         * @param name Текст вопроса
         * @param dataType Тип данных ответа
         */
        passQuestionParams({ commit }, { name, dataType }) {
            commit('setQuestionParams', { name, dataType });
        },
    },
};

export default PollQuests;





// WEBPACK FOOTER //
// ./src/store/modules/pollQuests.js